import styled from "styled-components";
import { createGradientOrSolid } from "../Helper/utils";

export const StyledMessagePage = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  min-height: ${(props: any) => props.preview ? "auto" : "100vh"};
  font-family: ${(props: any) => props.fontFamily};
  display: flex;
  flex-direction: column;
  justify-content: center;
  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 20px;
    margin: 0;
    h1 {
      margin: auto;
      max-width: 400px;
      display: flex;
      align-items: center;
      background: ${(props: any) => createGradientOrSolid(props.headerColors)};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    h2 {
      max-width: 450px;
      margin: 10px 0;
    }
    .coinsAnimation {
      position: absolute;
      width: 1024px;
      top: -250px;
    }
  }
` as any;
